export default __webpack_public_path__ + "static/media/CivilEng_Shapes-04.07e5ecfe.png";